import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _IconLumaPayOutlined;
var _excluded = ["iconMode", "color"];
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Button, IconButton, IconLumaPayOutlined } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FallbackButtonLumaPayRequest(_ref) {
  var iconMode = _ref.iconMode,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  if (iconMode) {
    return /*#__PURE__*/_jsx(IconButton, _extends({
      "aria-label": intl.formatMessage({
        id: "VcH3dd",
        defaultMessage: [{
          "type": 0,
          "value": "Request payment"
        }]
      }),
      variant: "smallBlack",
      color: color
    }, rest, {
      children: _IconLumaPayOutlined || (_IconLumaPayOutlined = /*#__PURE__*/_jsx(IconLumaPayOutlined, {}))
    }));
  }
  return /*#__PURE__*/_jsx(Button, _extends({}, rest, {
    children: intl.formatMessage({
      id: "VcH3dd",
      defaultMessage: [{
        "type": 0,
        "value": "Request payment"
      }]
    })
  }));
}